import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import _profileAssets from "../Components/Assets/Profile";
import { makeStyles } from "@material-ui/core/styles";
import "jspdf-autotable";
import axiosInstance from "../utilities/Axios";
import useQuery from "../Hooks/useQueryHook/useQueryHook";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, Button, Card, CircularProgress, Divider, Paper, Skeleton, Typography } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { pdf } from "@react-pdf/renderer";
import { CheckCircle } from "@mui/icons-material";
import Scaffold from "../Components/Layout/Scaffold";
import { pdfTypeEnum, SkillLevelDisplayEnum, SkillLevelEnum } from "../Types/Enum";
import { log } from "console";

const useStyles = makeStyles((theme) => ({
  table: {
    border: "1px solid black",
    padding: "3px",
    paddingBottom: "5px",
    textAlign: "left",
    fontSize: "small",
  },
  table_key: {
    fontWeight: "bold",
    fontSize: "12px",
    padding: "2px",
  },
  table_value: {
    textTransform: "uppercase",
    fontSize: "10px",
    padding: "2px",
  },
}));

const IMG_BASE_URL = process.env.REACT_APP_PUBLIC_FILE_PATH;

const ContentToConvert = ({ onCustomerReferenceChange }: { onCustomerReferenceChange: (reference: string) => void }) => {
  const classes = useStyles();
  const query = useQuery();
  const [loadState, setLoadState] = useState({
    profile_pic: false,
    full_pic: false,
    cover_img: false,
    basic_details: false,
    workExperience: false,
    skills: false,
    countries: false,
  })
  const [resume, setResume] = useState<any>({});
  const [age, setAge] = useState<number>();
  const [languages, setLanguages] = useState<String[]>([]);
  const [skillResumeList, setResumeSkillList] = useState<any[]>([]);
  const [PDFImage, setPDFImage] = useState<any>();
  const [PDFTemplate, setPDFTemplate] = useState<any>('non_exp');
  const [jobId, setJobId] = useState<any>();
  const [resumefixedId, setResumefixedId] = useState<any>();
  const [resumeCountryProcessList, setResumeCountryProcessList] = useState<
    any[]
  >([]);
  const [countryProcess, setCountryProcess] = useState<any>({});
  const [experienceList, setExperienceList] = useState<any[]>([]);
  const [attachmentProfilePic, setAttachmentProfilePic] = useState<any[]>([]);
  const [attachmentFullImage, setAttachmentFullImage] = useState<any[]>([]);


  useEffect(() => {
    const resumeId = query.get("resumeId");
    const countryProcessId = Number(query.get("countryProcess"));

    if (resumeId != null) {
      getResumeById("" + resumeId);
      getAttachmentProfilePic("" + resumeId);
      getAttachmentFullImage("" + resumeId);
      getCountryProcessById(countryProcessId);
      // getProcessCardByID(processId, EDialogAction.view);
    }
  }, []);



  useEffect(() => {
    ageCalculator();
    //languageArray();
    getExperienceList(resumefixedId);
  }, [resume]);

  useEffect(() => {
    if (countryProcess.title) {
      getPDFImage();
    }
  }, [countryProcess]);

  useEffect(() => {
    if (resume && resume.customer_reference) {
      onCustomerReferenceChange(resume.customer_reference);
    }
  }, [resume, onCustomerReferenceChange]);

  const getResumeById = async (resumeId: string) => {
    try {
      const response = await axiosInstance.get(`/v1/resume/${resumeId}`, {});

      const data = response.data;
      setResume(data.result);
      setResumefixedId(data.result.id);
      getResumeSkillList(data.result.id);
      //getResumeCountryProcessList(data.result.id);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadState(prev => ({ ...prev, basic_details: true, countries: true }))
    }
  };

  const getJobList = async (resumeId: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/resume-jobs?resume_id=${resumeId}`,
        {}
      );

      const data = response.data;

      setJobId(data.result[0].job_title);
    } catch (err) {
      console.log(err);
    }
  };

  const getResumeSkillList = async (resumeId: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/resume-skills?resume_id=${resumeId}`,
        {}
      );
      let uniqueSkills: any = [];
      const data = response.data;
      data.result.forEach((skill: any) => {
        const existingSkill = uniqueSkills.find(
          (s: any) => s.skill_id == skill.skill_id
        );
        if (!existingSkill) {
          uniqueSkills.push(skill);
        }
      });
      setResumeSkillList(uniqueSkills);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadState(prev => ({ ...prev, skills: true }))
    }
  };

  const getAttachmentProfilePic = async (resumeId: string) => {
    try {
      const response = await axiosInstance.get(
        `/v1/resume-attachments?resume_id=${resumeId}&attachment_tag=${"profile_pic"}`,
        {}
      );
      const data = response.data;
      setAttachmentProfilePic(data.result);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadState(prev => ({ ...prev, profile_pic: true }))
    }
  };

  const getAttachmentFullImage = async (resumeId: string) => {
    try {
      const response = await axiosInstance.get(
        `/v1/resume-attachments?resume_id=${resumeId}&attachment_tag=${"full_pic"}`,
        {}
      );
      const data = response.data;
      setAttachmentFullImage(data.result);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadState(prev => ({ ...prev, full_pic: true }))
    }
  };

  const getPDFImage = async () => {
    try {
      let pdfType = '';
      // if (resume.base_job_title === 'Cooking') {
      //   pdfType = pdfTypeEnum.Cooking;
      // } else if (experienceList.length > 0) {
      //   pdfType = pdfTypeEnum.Experienced;
      // }

      const response = await axiosInstance.get(`/v1/pdf-image?pdf_type=${countryProcess?.title}`, {
        //responseType: "arraybuffer",
      });
      const data = response.data;
      // const blob = new Blob([data.image], { type: "image/png" });

      // const url = URL.createObjectURL(blob)
      setPDFImage(IMG_BASE_URL + data.image);
      if (data?.pdf_template) {
        setPDFTemplate(data?.pdf_template);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadState(prev => ({ ...prev, cover_img: true }))
    }
  };
  const getResumeCountryProcessList = async (resumeId: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/resume-country?resume_id=${resumeId}&status=proc`,
        {}
      );
      const data = response.data;
      setResumeCountryProcessList(data.result);
      if (data.result.length > 0) {
        getCountryProcessById(data.result[0].id);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const getExperienceList = async (resumeId: String) => {
    try {
      const response = await axiosInstance.get(
        `/v1/work-experience?resume_id=${resumeId}`,
        {}
      );

      const data = response.data;
      setExperienceList(data.result);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadState(prev => ({ ...prev, workExperience: true }))
    }
  };
  const getCountryProcessById = async (countryProcessId: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/country-process/${countryProcessId}`,
        {}
      );

      const data = response.data;

      setCountryProcess(data.result);
    } catch (err) {
      console.log(err);
    }
  };


  const ageCalculator = async () => {
    if (resume && resume.birth_of_date) {
      const currentDate: Date = new Date();
      const birthDay: Date = new Date(resume.birth_of_date);
      const ageInMilliseconds: number =
        currentDate.getTime() - birthDay.getTime();
      const ageInYears: number =
        new Date(ageInMilliseconds).getUTCFullYear() - 1970;
      setAge(ageInYears);
    }
  };
  const languageArray = async () => {
    if (resume != null && resume.languages) {
      const languages = await resume.languages;
      const languagesArray = languages.split(",");
      setLanguages(languagesArray);
    }
  };
  const renderIcon = (data: any) => {
    if (data.skill_level === SkillLevelEnum.good || data.skill_level === SkillLevelEnum.very_good) {
      return <DoneIcon fontSize="small" />; // Checkmark
    } else {
      return <CloseIcon fontSize="small" />; // Cross mark
    }
  };
  if (!loadState.profile_pic || !loadState.full_pic || !loadState.cover_img || !loadState.basic_details || !loadState.workExperience || !loadState.skills || !loadState.countries) {
    return (
      <div className="flex flex-col justify-center h-[600px] space-y-4">
        <CircularProgress className="self-center" />
        <div className="text-center text-2xl">Generating Resume</div>
        <div className="text-center">{loadState.basic_details ? <CheckCircle color="success" /> : <CloseIcon />} Basic Details</div>
        <div className="text-center">{loadState.workExperience ? <CheckCircle color="success" /> : <CloseIcon />} Work Experience</div>
        <div className="text-center">{loadState.countries ? <CheckCircle color="success" /> : <CloseIcon />} Countries</div>
        <div className="text-center">{loadState.skills ? <CheckCircle color="success" /> : <CloseIcon />} Skills</div>
        <div className="text-center">{loadState.profile_pic ? <CheckCircle color="success" /> : <CloseIcon />} Profile Image</div>
        <div className="text-center">{loadState.full_pic ? <CheckCircle color="success" /> : <CloseIcon />} Full Image</div>
        <div className="text-center">{loadState.cover_img ? <CheckCircle color="success" /> : <CloseIcon />} Cover Image</div>
        <div className="max-w-md"><Alert severity="info">Kindly remain patient as we generate your resume. If the process appears to be taking an extended period of time, please revisit and verify the details of your resume.</Alert></div>
      </div>
    );
  } else return (
    <div style={{ border: `4px solid white`, maxWidth: "794px" }}>
      <section>
        <div>
          <img src={PDFImage} width={"100%"} />
        </div>
      </section>
      <section className="-mb-8">
        <div className="flex justify-end w-2/3 mt-2 font-extrabold">
          JOB APPLICATION
        </div>
        <div className="flex flex-row ">
          <div className="w-4/5 mr-2">
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Reference No
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>
                    {resume.customer_reference}
                  </td>
                </tr>
                <tr>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Sex / الجنس
                  </td>
                  {resume.gender == "M" ? (
                    <td className={`${classes.table} ${classes.table_value}`}>{"Male"}</td>
                  ) : (
                    <td className={`${classes.table} ${classes.table_value}`}>{"Female"}</td>
                  )}
                </tr>
                <tr>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Age / العمر
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>{age}</td>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Country Applied / بلد العمل
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>{countryProcess.country_name}</td>
                </tr>
                <tr>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Job / العمل
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>{countryProcess?.title}</td>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Moth. Salary / الراتب الشهري
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>{resume.month_salary} {resume.salary_currency}</td>
                </tr>
                <tr>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Full Name / الإسم الكامل
                  </td>
                  <td colSpan={3} className={`${classes.table} ${classes.table_value}`}>
                    {resume.first_name} {resume.last_name}
                  </td>
                </tr>
                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
          <div>
            <img
              src={
                attachmentProfilePic[0]
                  ? IMG_BASE_URL + attachmentProfilePic[0].attachment_url
                  : "https://images.placeholders.dev/?text=NO-IMAGE&bgColor=%23f7f6f6&textColor=%236d6e71&height=300&fontSize=50"
              }
              // src={_profileAssets.image_3}
              //   width={"60%"}
              style={{ marginRight: "8px", marginBottom: '3px', height: "35mm", width: "25mm", objectFit: "contain", borderRadius: "4px" }}
            />
          </div>
        </div>
      </section>
      <section>
        <div
          className="flex w-full mt-8"
          style={{
            backgroundColor: pdfTypeEnum[PDFTemplate]?.color,
            color: "white",
            justifyContent: "center",
            border: "1px solid black",
            fontSize: "medium",
          }}
        >
          Details of Applicant
        </div>
        <div className="flex flex-row mt-2">
          <div className="w-full mr-2 ">
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Nationality / الجنسية
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>Sri Lankan</td>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Religion / الديانة
                  </td>
                  <td colSpan={2} className={`${classes.table} ${classes.table_value}`}>
                    {resume.religion}
                  </td>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Height
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>
                    {resume.height_unit === 'inch' ? `${resume.foot}'${resume.height}"` : `${Math.floor(resume.height / 30.48)}'${((resume.height % 30.48) / 2.54).toFixed(1)}"`}
                  </td>
                </tr>
                <tr>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    DOB / تاريخ الميلاد
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>{resume.birth_of_date}</td>
                  <td
                    className={`${classes.table} ${classes.table_key}`}
                  ></td>
                  <td colSpan={2} className={`${classes.table} ${classes.table_value}`}></td>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Weight
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>{resume.weight}KG</td>
                </tr>
                <tr>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    POB / مكان الميلاد
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>{resume.place_of_birth}</td>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Qua./ المؤهلات
                  </td>
                  <td colSpan={2} className={`${classes.table} ${classes.table_value}`}>
                    {resume.qua}
                  </td>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    No. of Children
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>{resume.number_of_children}</td>
                </tr>
                <tr>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Maritial St. / الحالة الاجتماعية
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>{resume.marital_status}</td>
                  <td
                    rowSpan={2}
                    className={`${classes.table} ${classes.table_key}`}
                  >
                    Language / اللغة
                  </td>
                  {resume.languages ? (
                    <>
                      <td rowSpan={2} className={`${classes.table} ${classes.table_value}`}>
                        {resume.languages.map((lang: any, index: number) => (
                          <span key={index}>
                            {lang.name}
                            {index !== resume.languages.length - 1 && <hr style={{ margin: 0 }} />}
                          </span>
                        ))}
                      </td>
                      <td rowSpan={2} className={`${classes.table} ${classes.table_value}`}>
                        {resume.languages.map((lang: any, index: number) => (
                          <span key={index}>
                            {lang.level}
                            {index !== resume.languages.length - 1 && <hr style={{ margin: 0 }} />}
                          </span>
                        ))}
                      </td>
                    </>
                  ) : (
                    <>
                      <td rowSpan={2} className={`${classes.table} ${classes.table_value}`}></td>
                      <td rowSpan={2} className={`${classes.table} ${classes.table_value}`}></td>
                    </>
                  )}

                  <td colSpan={2} rowSpan={2} className={`${classes.table} ${classes.table_value}`}></td>
                </tr>
                <tr>
                  <td className={`${classes.table} ${classes.table_key}`}>
                    Look / الشكل
                  </td>
                  <td className={`${classes.table} ${classes.table_value}`}>{resume.look}</td>
                  {/* <td className={classes.table}>{languages[1]}</td>
                  <td className={classes.table}>{ }</td> */}
                </tr>
                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section>
        <div className="flex flex-row w-full">
          <div className="flex flex-col w-3/5">
            <div className="w-full">
              <div
                className="flex  w-full mt-2"
                style={{
                  backgroundColor: pdfTypeEnum[PDFTemplate]?.color,
                  color: "white",
                  justifyContent: "center",
                  border: "1px solid black",
                  fontSize: "medium",
                }}
              >
                Passport Details
              </div>
              <div className=" mt-2">
                <div className="w-full mr-2 ">
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td
                          className={`${classes.table} ${classes.table_key}`}
                        >
                          Passport No. /رقم جواز السفر
                        </td>
                        <td
                          className={`${classes.table} ${classes.table_value}`}
                        >
                          {resume.passport_no}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className={`${classes.table} ${classes.table_key}`}
                        >
                          Date of Issue / تاريخ الإصدار
                        </td>
                        <td className={`${classes.table} ${classes.table_value}`}>
                          {resume.passport_date_of_issue}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className={`${classes.table} ${classes.table_key}`}
                        >
                          Date of Exp / تاريخ الإنتهاء
                        </td>
                        <td className={`${classes.table} ${classes.table_value}`}>
                          {resume.passport_expire_date}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className={`${classes.table} ${classes.table_key}`}
                        >
                          Place of Issue / مكان الإصدار
                        </td>
                        <td className={`${classes.table} ${classes.table_value}`}>
                          {resume.passport_place_of_issue}
                        </td>
                      </tr>

                      {/* Add more rows as needed */}
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className="flex w-full mt-2"
                style={{
                  backgroundColor: pdfTypeEnum[PDFTemplate]?.color,
                  color: "white",
                  justifyContent: "center",
                  border: "1px solid black",
                  fontSize: "medium",
                }}
              >
                Work Experience
              </div>
              <div className="mt-2">
                <div>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <th
                          className={`${classes.table} ${classes.table_key}`}
                        >
                          Country / البلد
                        </th>
                        <th
                          className={`${classes.table} ${classes.table_key}`}
                        >
                          Duration / المدة
                        </th>
                        <th
                          className={`${classes.table} ${classes.table_key}`}
                        >
                          Job Title / المهنة
                        </th>
                      </tr>
                      {experienceList.map((data: any, key: number) => (
                        <tr>
                          <td className={`${classes.table} ${classes.table_value}`} key={key}>
                            {data.note}
                          </td>
                          <td className={`${classes.table} ${classes.table_value}`} key={key}>
                            {data.duration}Y {data.duration_months ? `${data.duration_months}M` : ''}
                          </td>
                          <td className={`${classes.table} ${classes.table_value}`} key={key}>
                            <div className="w-full">{data.job_title ? data.job_title.title : data.job_title_id}</div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className="flex w-full mt-2"
                style={{
                  backgroundColor: pdfTypeEnum[PDFTemplate]?.color,
                  color: "white",
                  justifyContent: "center",
                  border: "1px solid black",
                  fontSize: "medium",
                }}
              >
                Skills
              </div>
              <div className="mt-2">
                <div className="w-full mr-2 ">
                  <table style={{ width: "100%" }}>
                    <tbody>
                      {skillResumeList != null ? (
                        skillResumeList.map((data: any, key: number) => (
                          <tr key={key}>
                            <td className={`${classes.table} ${classes.table_value}`}>
                              {data.skill_title}
                            </td>
                            <td className={`${classes.table} ${classes.table_value}`}>
                              {renderIcon(data)}
                            </td>
                            <td className={`${classes.table} ${classes.table_value}`}>
                              {SkillLevelDisplayEnum[data.skill_level]}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className="flex w-full mt-2"
                style={{
                  backgroundColor: pdfTypeEnum[PDFTemplate]?.color,
                  color: "white",
                  justifyContent: "center",
                  border: "1px solid black",
                  fontSize: "medium",
                }}
              >
                Remarks
              </div>
              <div className=" mt-2">
                <div className="w-full">
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td className={`${classes.table} ${classes.table_value}`} style={{ whiteSpace: "pre-wrap" }}>{resume.remark ?? "\u00A0"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="w-2/5">
            <img
              src={
                attachmentFullImage[0]
                  ? IMG_BASE_URL + attachmentFullImage[0].attachment_url
                  : "https://images.placeholders.dev/?text=NO-IMAGE&bgColor=%23f7f6f6&textColor=%236d6e71&height=430&fontSize=50"
              }
              width={"90%"}
              style={{
                marginLeft: "5%",
                marginTop: "3%",
                height: "95%",
                objectFit: "cover",
                borderRadius: "4px"
              }}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

const PdfConverter = () => {
  const contentRef = useRef(null);
  const [customerReference, setCustomerReference] = useState("");

  const handlePrint = useReactToPrint({
    content: () => contentRef.current,
    documentTitle: customerReference || "Resume",
  });

  const handleCustomerReferenceChange = (reference: string) => {
    setCustomerReference(reference);
  };

  const handleConvertToPdf = async () => {
    const content = contentRef.current;

    if (content) {
      try {
        const originalWidth = 500; // replace with the actual width of your image
        const originalHeight = 600; // replace with the actual height of your image
        const desiredWidth = 200;
        const calculatedHeight =
          (desiredWidth / originalWidth) * originalHeight;
        // const canvas = await html2canvas(content);
        const canvas = await html2canvas(content, { scale: 2 }); // Increase scale for higher resolution
        const imgData = canvas.toDataURL("image/jpeg");
        const pdf = new jsPDF({
          unit: "mm",
          format: "a4",
        });
        pdf.addImage(imgData, "JPEG", 0, 0, 210, 297);
        // pdf.autoTable({
        //   startY: 100, // Adjust the starting Y position as needed
        //   html: content,
        // }); // Adjust the dimensions as needed
        pdf.save("converted.pdf");
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    }
  };

  return (
    <Scaffold
      title="Resume Preview"
      showBackButton
      actions={[]}
      mainAction={<Button variant="contained" color="primary" onClick={handlePrint}>
        EXPORT PDF
      </Button>}
    >
      <Card className="flex justify-center items-center p-2 my-4">
        <div ref={contentRef}>
          <ContentToConvert onCustomerReferenceChange={handleCustomerReferenceChange} />
        </div>
      </Card>
    </Scaffold>
  )
  return (
    <div>
      <div className="flex justify-between">
        <Typography sx={{ fontSize: 24, fontWeight: "bold" }} gutterBottom>
          Resume Preview
        </Typography>
        <Button variant="contained" color="primary" onClick={handlePrint}>
          EXPORT PDF
        </Button>
      </div>
      <Card className="flex justify-center items-center p-2 my-4">
        <div ref={contentRef}>
          <ContentToConvert onCustomerReferenceChange={handleCustomerReferenceChange} />
        </div>
      </Card>
    </div>
  );
};

export default PdfConverter;
